/* ------------------------------------------------------------------------ */
/*		File: ApplyNow.tsx                                                  */
/*		Description: Apply page definition                                  */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

/* eslint-disable react/jsx-pascal-case */

import React, { useEffect, useRef, useState } from "react";
import Menu from "../../components/cmpMenu/cmpMenu";
import IntroComponent from "../../components/cmpIntro/cmpIntro";
import Step from "../../components/cmpStep/cmpStep";
import Faq from "../../components/cmpFAQ/cmpFAQ";
import { useTranslation, withTranslation } from "react-i18next";
import crypt from "crypto-js";
import "../../scss/general.css";
import "./applynow.css";
import FormApply from "../../components/cmpFormApply/cmpFormApply";
import Card_Breadcumb from "../../components/cmpBreadcumb/cmpBreadcumb";

import 'react-toastify/dist/ReactToastify.css';
import Meta from "../../components/GenericComponents/meta";
import { useParams } from "react-router-dom";

/* ------------------------------------------------------------------------ */

const ApplyNow: React.FC = () => {

    const { t } = useTranslation();
    const webId = useParams();
    const [campaign, setCampaign] = useState<any>(webId || null)

    const trialClassRef = useRef<HTMLElement>(null);

    const infoMenus: any = t("menu", { returnObjects: true });
    const infoApplyNow: any = t("applyNow", { returnObjects: true });
    const infoPolicy: any = t("policy", { returnObjects: true });
    const infoOthers:any = t("others", { returnObjects: true });
    const detailMenu = infoMenus.filter((x: any) => x.id === "applynow")[0] || null;

    useEffect(() => {
        if (campaign !== null && campaign.hasOwnProperty("webId")) {
            let tmpCampaign = campaign.webId.replace(/-/g, '+').replace(/_/g, '/') + "==";
            tmpCampaign = JSON.parse(crypt.AES.decrypt(tmpCampaign, process.env.REACT_APP_ENCRYPTKEY!).toString(crypt.enc.Utf8));
            setCampaign(tmpCampaign);
            trialClassRef.current?.scrollIntoView({ behavior: 'smooth' });
        } else { setCampaign(null) }
        return () => {
            setCampaign(null);  
        }
    }, [])


    return (
        <div className="header-parent">
            <Meta page={"applyNow"} />
            <div className="cssApplyNow">
                <Menu
                    label={detailMenu!.label}
                    options={detailMenu!.submenus}
                    buttons={detailMenu!.buttons}
                    quotation={detailMenu!.quotation}
                />

                <div className="cssCol">
                    <Card_Breadcumb label={infoApplyNow.breadcumb} />

                    <IntroComponent
                        label={infoApplyNow.label}
                        description={infoApplyNow.description}
                    />

                    {/* Section: Apply now */}

                    <section id="applyNow">
                        <IntroComponent
                            label={infoApplyNow.content[0].label}
                            description={infoApplyNow.content[0].description}
                        />

                        <div className="cssRowCenter">
                            {infoApplyNow.content[0].content.map((item: any, index: number) => (
                                <Step
                                    key={`infoApplyNow-${index}`}
                                    description={item.description}
                                    src={item.src}
                                />
                            ))}
                        </div>
                    </section>

                    {/* Section: Form */}

                    <section id="trialClass" ref={trialClassRef}>
                        <IntroComponent
                            label={infoApplyNow.content[1].label}
                            description={infoApplyNow.content[1].description}
                        />
                        <div className="cssRowCenter">
                            <FormApply
                                fields={infoApplyNow.content[1].content}
                                validations={infoApplyNow.content[1].validations}
                                buttons={infoApplyNow.content[1].buttons}
                                policy={infoPolicy}
                                msgError={infoOthers.msgError}
                                campaign={campaign}
                            />
                        </div>
                    </section>

                    {/* Section: FAQ */}

                    <section id="faq">
                        <IntroComponent
                            label={infoApplyNow.content[2].label}
                            description={infoApplyNow.content[2].description}
                        />
                        <Faq
                            questions={infoApplyNow.content[2].content}
                        />
                    </section>
                </div>
            </div>

        </div>
    );
};
export default withTranslation('translation', { withRef: true }) (ApplyNow);